import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';

@Component({
  selector: 'app-fr-card',
  templateUrl: './fr-card.component.html',
  styleUrls: ['./fr-card.component.scss']
})
export class FrCardComponent implements OnInit {

  constructor(
    private router: Router
  ) { }
  marginTopZero = false;

  ngOnInit() {
    if (this.router.url.split('/')[1] === 'stories') {
      this.marginTopZero = true;
    }
  }

}
